<template>
  <div class="resetPassword">
    <div class="img"></div>
    <p>{{userName}}，初次登录，请修改密码！</p>
    <div class="form">
      <div>
        <input ref="oldPassword" @blur="validateOldPassword(form.oldPassword)" v-model="form.oldPassword" placeholder="请输入原登录密码" type="password" />
        <span v-show="oldPasswordText.length">{{oldPasswordText}}</span>
      </div>
      <div>
        <input ref="newPassword" @blur="validateNewPassword(form.newPassword)" v-model="form.newPassword" placeholder="请输入新登录密码" type="password" />
        <span v-show="newPasswordText.length">{{newPasswordText}}</span>
      </div>
      <div>
        <input ref="confirmPassword" @blur="validateConfirmPassword(form.confirmPassword)" type="password" v-model="form.confirmPassword" @keyup.enter.native="submit('form')" autocomplete="new-password" placeholder="请再次输入登录密码">
        <span v-show="confirmPasswordText.length">{{confirmPasswordText}}</span>
      </div>
      
    </div>
    <div class="reset" @click="reset">确 定</div>
  </div>
</template>
<script>
import api from '@/api'
export default {
  data() {
    return {
      form: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
      },
      userName: '',
      oldPasswordText: '',
      newPasswordText: '',
      confirmPasswordText: ''
    }
  },
  created() {
    this.getUserInfo()
  },
  methods: {
    reset() {
      if(this.validateOldPassword(this.form.oldPassword) && this.validateNewPassword(this.form.newPassword) && this.validateConfirmPassword(this.form.confirmPassword)) {
        this.$put(api.login.changePassword(), this.form).then(res => {
          if (res.status === 1) {
            localStorage.removeItem("x_token");
            this.$toast({
              message: '修改密码成功请重新登录!',
              duration: 1000,
              position: 'bottom'
            })
            this.$nextTick(() => {
              this.$router.push({
                path: "/login"
              });
            });
          } else {
            this.$toast({
              message: res.message,
              duration: 1000,
              position: 'bottom'
            })
          }
        });
      }
    },
    getUserInfo() {
      this.$get(api.home.userInfo()).then(res => {
        if(res.status === 1) {
          console.log(res)
          this.userName = res.data.userName
        } else if(res.status === 0) {
          this.$toast({
            message: res.message,
            duration: 1000,
            position: 'bottom'
          })
          this.logout()
        }
      })
    },
    validateOldPassword(val) {
      if(val.length === 0) {
        this.oldPasswordText = '请输入原登陆密码'
        this.$refs.oldPassword.className = 'validateFalse'
        return false
      } else {
        this.oldPasswordText = ''
        this.$refs.oldPassword.className = 'validateTrue'
        return true
      }
    },
    validateNewPassword(val) {
      if(val.length === 0) {
        this.newPasswordText = '请输入新登陆密码'
        this.$refs.newPassword.className = 'validateFalse'
        return false
      } else if(!(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,20}$/.test(val))) {
        this.newPasswordText = '密码6至20位，必须包含字母与数字'
        this.$refs.newPassword.className = 'validateFalse'
        return false
      } else {
        this.newPasswordText = ''
        this.$refs.newPassword.className = 'validateTrue'
        return true
      }
    },
    validateConfirmPassword(val) {
      if(val.length === 0) {
        this.confirmPasswordText = '请再次输入登录密码'
        this.$refs.confirmPassword.className = 'validateFalse'
        return false
      } else if(this.form.newPassword !== this.form.confirmPassword) {
        this.confirmPasswordText = '两次输入的密码不一致'
        this.$refs.confirmPassword.className = 'validateFalse'
        return false
      } else {
        this.confirmPasswordText = ''
        this.$refs.confirmPassword.className = 'validateTrue'
        return true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.resetPassword {
  min-height: 100vh;
  padding: 156px 50px 0 48px;
  background-color: #fff;
  .img {
    width:197px;
    height:213px;
    margin: 0 auto 40px;
    background-image: url('../../assets/touxiang.png');
    background-size: 100% 100%;
  }
  >p {
    font-size:32px;
    font-weight:bold;
    text-align: center;
    letter-spacing: $letter-spacing;
    margin-bottom: 110px;
  }
  .form {
    // margin-top: 220px;
    div {
      margin-bottom: 121px;
      position: relative;
      input {
        width: 100%;
        padding-bottom: 30px;
        padding-left: 10px;
        border: 0;
        border-bottom: 2px solid rgba(238,238,238,1);
        letter-spacing: 3px;
        font-size:30px;
        font-family:PingFangSC;
        font-weight:400;
        
        color:#323232;
        &::-webkit-input-placeholder {
          /* placeholder颜色  */
          color: #ccc;
          /* placeholder字体大小  */
          font-size: 30px;
          /* placeholder位置  */
          text-align: left;
        }
        &.validateTrue {
          border-color: #03B187;
        }
        &.validateFalse {
          border-color: #FF5858;
        }
      }
      span {
        font-size: 26px;
        color: #FF5858;
        position: absolute;
        top: 80px;
        left: 0;
      }
    }
  }
  .reset {
    height:100px;
    width: 100%;
    line-height: 100px;
    text-align: center;
    // margin-top: 120px;
    @include linear-gradient(rgba(142,233,202,1) 0%,rgba(3,177,135,1) 100%);
    font-size:30px;
    font-family:PingFangSC;
    font-weight:600;
    color:rgba(255,255,255,1);
    border-radius: 50px;
    box-shadow:0px 0px 30px 0px rgba(156,233,200,0.6);
  }
}
</style>